import ready from "../utils/ready";
import {
  attachValidation
} from "../components/form";

ready().then(() => {
  const btnUpload = document.querySelector('#btnUpload');
  if (btnUpload) {
    btnUpload.onclick = () => {
      const progressBar = document.querySelector('#progressBar');
      if (progressBar) {
        progressBar.classList.remove('is-hidden');
        btnUpload.classList.add('is-hidden');
      }
    }
  }

  const fileInput = document.querySelector('#file-upload input[type=file]');
  if (fileInput) {
    fileInput.onchange = () => {
      if (fileInput.files.length > 0) {
        const fileName = document.querySelector('#file-upload .file-name');
        fileName.textContent = fileInput.files[0].name;

        if (btnUpload) {
          btnUpload.removeAttribute("disabled");
          btnUpload.focus();
        }
      }
    }
  }

  const btnDownload = document.querySelector('#btnDownload');
  if (btnDownload) {
    btnDownload.onclick = () => {
      const btnBack = document.querySelector('#btnBack');
      const dlBack = document.querySelector('#dlBack');
      const dlInfo = document.querySelector('#dlInfo');
      const dlFile = document.querySelector('#dlFile');

      if (btnBack && dlBack && dlInfo && dlFile) {
        dlInfo.classList.add('is-hidden');
        dlFile.classList.add('is-hidden');
        btnDownload.classList.add('is-hidden');
        dlBack.classList.remove('is-hidden');
        btnBack.classList.remove('is-hidden');
      }
    }
  }
});
